import React, {useEffect} from "react";
import {Link, Navigate, useParams} from "react-router-dom";

import styles from "./BulkUpdatePage.module.css";
import {useAppDispatch} from "../../../../app/hooks";
import {MenuItem, updateSelectedMenuItem} from "../../platform/platformSlice";
import {BulkUpdateFilePanel} from "../panel/BulkUpdateFilePanel";
import {findBulkUpdate} from "../bulkUpdateDefinitions";

export const BulkUpdateDetailsPage: React.FC = () => {
    const dispatch = useAppDispatch();
    const {bulkUpdateKey} = useParams();
    const definition = findBulkUpdate(bulkUpdateKey);

    useEffect(() => {
        dispatch(updateSelectedMenuItem(MenuItem.BULK_UPDATE));
    }, [dispatch]);

    if (!definition) {
        return <Navigate to={"/bulk-update"} replace/>;
    }

    return <div className={styles.wrapper}>
        <Link to={"/bulk-update"} className={styles.backLink}>
            <img src={"/arrowIcon.svg"} alt={""} className={styles.backIcon}/>
            <span>Bulk update</span>
        </Link>
        <div className={styles.detailsHeader}>
            <img className={styles.detailsLogo} src={definition.iconSrc} alt={""}/>
            <div className={styles.titleWrapper}>
                <span className={styles.title}>{definition.title}</span>
                <p className={styles.description}>{definition.description}</p>
            </div>
        </div>
        <BulkUpdateFilePanel key={definition.key} definition={definition}/>
    </div>
}
